import { useQuery } from '@tanstack/react-query'

import { apiGetJackpotWinner } from '@/apis/winner/getJackpotWinner'

import { WINNER_KEYS } from '../keys/winner'

/** 잭팟 당첨자 — 세션당 1회. 실패는 apiGetJackpotWinner 가 null 로 흡수한다(재시도 대상 아님) */
export const useGetJackpotWinner = () =>
  useQuery({
    queryKey: [WINNER_KEYS.JACKPOT],
    queryFn: apiGetJackpotWinner,
    staleTime: Infinity,
    retry: false,
  })
